import { useCallback, useState } from 'react';

export const useModal = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const closeModal = useCallback(() => {
    setIsOpenModal(false);
  }, []);

  const openModal = useCallback(() => setIsOpenModal(true), []);

  return { isOpenModal, openModal, closeModal };
};
